import { getScrollPosition } from '../utils/scroll-position';
import { supportsPassiveEvents } from '../utils/feature-detects';

const UP = 'up';
const DOWN = 'down';

let topBarHeight = 0;
let header = document.querySelector('.js-header');
let topBar = document.querySelector('.c-header__top');
let eventOptions = supportsPassiveEvents() ? { passive: true } : false;

let classes = {
	sticky: 'is-sticky',
	animated: 'is-animated',
};

let lastScrollY = 0;
let tolerance = { up: 10, down: 10 };
let topbarOffset = { top: 0, bottom: 0 };

let isSticky = false;
let isStuck = false;

let resizing = false;

export function init() {
	if ((!header) || (!topBar)) {
		return;
	}

	isSticky = header.dataset.sticky === '1';

	/**
	 * Defer event registration to handle browser potentially restoring previous
	 * scroll position.
	 */
	setTimeout(function init() {
		calcLayout();
		updateScroll();

		window.addEventListener('resize', onResize, eventOptions);
		document.addEventListener('scroll', onScroll, eventOptions);
	});
}

export function calcLayout() {
	let { y: scrollY } = getScrollPosition();

	let topBarRect = topBar.getBoundingClientRect();

	topBarHeight = topBarRect.height;
	topbarOffset.bottom = topBarHeight + scrollY;

	resizing = false;
}

export function freeze() {
	if (!isSticky) {
		return;
	}

	document.removeEventListener('scroll', updateScroll, eventOptions);
}

export function unfreeze() {
	if (!isSticky) {
		return;
	}

	document.addEventListener('scroll', updateScroll, eventOptions);
}

function updateScroll() {
	let { y: scrollY } = getScrollPosition();
	let distance = Math.abs(scrollY - lastScrollY);
	let direction = scrollY < lastScrollY ? UP : DOWN;
	let toleranceExceeded = distance > tolerance[direction];

	lastScrollY = scrollY;

	if ((topBarHeight == 0) && (scrollY >= 5)) {
		stick();

		return;
	} else if ((topBarHeight == 0) && (scrollY < 5)) {
		reset();

		return;
	}

	if (isStuck && ((scrollY < topBarHeight) || (topBarHeight == 0))) {
		reset();

		return;
	}

	if (!isStuck && scrollY >= topBarHeight) {
		stick();

		return;
	}

	if (!isStuck || !toleranceExceeded) {
		return;
	}
}


function reset() {
	isStuck = false;
	header.classList.remove(classes.sticky);
}

function stick() {
	isStuck = true;
	header.classList.add(classes.sticky);
}


function onScroll() {
	if (resizing) {
		return;
	}

	updateScroll();
}

function onResize() {
	if (resizing) {
		return;
	}

	resizing = true;
	requestAnimationFrame(calcLayout);
}
